// extracted by mini-css-extract-plugin
export default {"accordionButton":"SystemSettings_accordionButton__Wjkzj"};